import styled from 'styled-components';

export const Container = styled.div`
    table {
        width: 100%;
    }

    th {
        background-color: #c9cbce;
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        padding: 8px 15px;
        text-align: left;
    }

    td {
        border-bottom: 1px solid #37414e;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        padding: 12px 15px;
    }
`;

export const Title = styled.h1`
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 48px;
`;

export const SubTitle = styled.h2`
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
`;

export const Entry = styled.div`
    margin-bottom: 2em;

    .heading {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        margin: 15px 0px 0px;
    }
`;
